import { apiFetch, apiAction } from 'utils';

import * as constants from '../constants/index';

export const previewMMS = (mms) =>
  apiAction(constants.BEGIN_MMS_PREVIEW, constants.SUCCESS_MMS_PREVIEW, constants.ERROR_MMS_PREVIEW,
    (state) =>
      apiFetch.post(
        state,
        'preview_mms/',
        mms
      ),
    {}
  );

export const createMMS = (mms) =>
  apiAction(constants.BEGIN_SAVING_MMS, constants.SUCCESS_SAVING_MMS, constants.ERROR_SAVING_MMS,
    (state) =>
      apiFetch.post(
        state,
        'mms/',
        mms
      ),
    {}
  );
